/**
 * Retrouve la salle vidéo d'un rendez-vous À PARTIR DE SA RÉSERVATION.
 *
 * Depuis la migration 0255 il y a UNE salle par CRÉNEAU : dans un cours collectif,
 * `video_rooms.reservation_id` n'est que la réservation qui a CRÉÉ la salle — les
 * autres élèves n'y figurent pas. Chercher `video_rooms` par `reservation_id` seul
 * ne trouve donc la salle que pour le premier arrivé (dialogue/résumé absents pour
 * les autres, et pour le tuteur qui ouvre la réservation d'un autre élève). On passe
 * par le créneau de la réservation, avec repli sur la salle historique.
 *
 * `null` = la salle n'a pas encore été créée (personne n'a rejoint).
 */

import type { SupabaseClient } from '@supabase/supabase-js';

export async function fetchVisioRoomId(
  db: SupabaseClient,
  reservationId: string,
): Promise<string | null> {
  const { data: reservation, error: reservationError } = await db
    .from('tutor_booking_reservations')
    .select('slot_id')
    .eq('id', reservationId)
    .maybeSingle();
  if (reservationError) throw new Error(reservationError.message);

  const slotId = (reservation as { slot_id: string | null } | null)?.slot_id;
  if (slotId) {
    const { data, error } = await db
      .from('video_rooms')
      .select('id')
      .eq('slot_id', slotId)
      .maybeSingle();
    if (error) throw new Error(error.message);
    if (data) return (data as { id: string }).id;
  }

  const { data, error } = await db
    .from('video_rooms')
    .select('id')
    .eq('reservation_id', reservationId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return (data as { id: string } | null)?.id ?? null;
}
